import { render, staticRenderFns } from "./TablesBasic.vue?vue&type=template&id=2ce7ba4e&"
import script from "./TablesBasic.vue?vue&type=script&lang=js&"
export * from "./TablesBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports